export default "__VITE_ASSET__Ji3NJm0___"